import { TradingHour, ParsedOpeningHour } from './types'
import { stripStatus } from './strip-status'
import { parseCentreOrLinkedStoreHours } from './parse-centre-or-linked-store-hours'

export function parseCentreOpeningHours(
  tradingHours: TradingHour[],
  centreTimeZone: string,
  centreFeatures?: string[]
): ParsedOpeningHour[] {
  return stripStatus(
    parseCentreOrLinkedStoreHours(tradingHours, centreTimeZone, centreFeatures)
  )
}
